package com.loyola.acessoescola.ui.adminpanel

import acessoescola.composeapp.generated.resources.Res
import acessoescola.composeapp.generated.resources.bound
import acessoescola.composeapp.generated.resources.cloud_sync_24px
import acessoescola.composeapp.generated.resources.connecting_to_server
import acessoescola.composeapp.generated.resources.content_copy_24px
import acessoescola.composeapp.generated.resources.cpf
import acessoescola.composeapp.generated.resources.delete_24px
import acessoescola.composeapp.generated.resources.download_24px
import acessoescola.composeapp.generated.resources.facial
import acessoescola.composeapp.generated.resources.full_name
import acessoescola.composeapp.generated.resources.phone
import acessoescola.composeapp.generated.resources.search_activity_24px
import acessoescola.composeapp.generated.resources.sync_24px
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.IntrinsicSize
import androidx.compose.foundation.layout.PaddingValues
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxHeight
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.lazy.LazyColumn
import androidx.compose.foundation.lazy.items
import androidx.compose.material3.Button
import androidx.compose.material3.Card
import androidx.compose.material3.CardDefaults
import androidx.compose.material3.Checkbox
import androidx.compose.material3.HorizontalDivider
import androidx.compose.material3.Icon
import androidx.compose.material3.IconButton
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Scaffold
import androidx.compose.material3.Text
import androidx.compose.material3.VerticalDivider
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.State
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.layout.ContentScale
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.unit.dp
import com.loyola.acessoescola.services.adminpanel.EventType
import com.loyola.acessoescola.services.adminpanel.LogEntry
import com.loyola.acessoescola.services.quintadb.ErrorMessages
import com.loyola.acessoescola.ui.components.ErrorDialog
import com.loyola.acessoescola.ui.components.Loading
import io.kamel.image.KamelImage
import io.kamel.image.asyncPainterResource
import kotlinx.browser.window
import org.jetbrains.compose.resources.stringResource
import org.jetbrains.compose.resources.vectorResource

@Composable
actual fun AdminPanelScreen(
    paddingValues: PaddingValues,
    viewModel: AdminPanelViewModel
){
    val uiState by viewModel.uiState.collectAsState()

    if (uiState.errorMessage != "") {
        ErrorDialog(
            errorMessage = uiState.errorMessage,
            onErrorMessageChange = { viewModel.onErrorMessageChange(it) }
        )
    }

    LaunchedEffect("") {
        viewModel.updateLogList { viewModel.onErrorMessageChange(it ?: ErrorMessages.UNKNOWN.message) }
    }

    if (uiState.isLogsLoading) {
        Box(
            contentAlignment = Alignment.Center,
            modifier = Modifier.fillMaxSize()
        ) {
            Loading(
                message = stringResource(Res.string.connecting_to_server),
                modifier = Modifier.fillMaxHeight(0.5f).fillMaxWidth(0.5f)
            )
        }
    } else {
        AdminPanel(
            paddingValues,
            viewModel,
            uiState
        )
    }
}

@Composable
private fun AdminPanel(
    paddingValues: PaddingValues,
    viewModel: AdminPanelViewModel,
    uiState: AdminPanelState
) {

    val logs by viewModel.logs.collectAsState()
    val activeLogEntry: LogEntry? = logs.firstOrNull() { it.LogId == uiState.activeLogEntry }


    if (uiState.errorMessage != "") {
        ErrorDialog(
            errorMessage = uiState.errorMessage,
            onErrorMessageChange = { viewModel.onErrorMessageChange(it) }
        )
    }

    Scaffold(modifier = Modifier.padding(paddingValues)) { _ ->
        Row(modifier = Modifier.padding(horizontal = 8.dp)) {
            Column(modifier = Modifier.fillMaxWidth(0.7f)) {
                LogEntryRow(
                    eventTimeStamp = "Data e Hora",
                    eventDetail = "Detalhes",
                    eventType = "Tipo",
                    databaseName = "Banco de dados",
                    Clickable = {
                        IconButton(
                            onClick = {
                                viewModel.updateLogList {
                                    viewModel.onErrorMessageChange(it ?: ErrorMessages.UNKNOWN.message)
                                }
                            }
                        ) {
                            Icon(
                                imageVector = vectorResource(Res.drawable.sync_24px),
                                contentDescription = "Atualizar"
                            )
                        }
                    },
                    modifier = Modifier.padding(horizontal = 8.dp)
                )
                LazyColumn {
                    items(logs) { logEntry ->
                        LogEvent(
                            isSelected = logEntry.LogId == uiState.activeLogEntry,
                            eventTimeStamp = logEntry.EventTimeStamp,
                            eventDetail = logEntry.EventDetail,
                            eventType = logEntry.EventType,
                            databaseName = logEntry.DatabaseName,
                            onSelectionChange = {
                                viewModel.resetState()
                                viewModel.onActiveLogEntryChange(
                                    logEntryID = logEntry.LogId,
                                    recordID = logEntry.RecordID,
                                    onErrorCallback = {
                                        viewModel.onErrorMessageChange(it ?: ErrorMessages.UNKNOWN.message)
                                    },
                                    eventType = logEntry.EventType
                                )
                            }
                        )
                    }
                }
            }
            VerticalDivider()
            if (activeLogEntry != null && activeLogEntry.EventType != EventType.DELETE.value) {
                RecordData(
                    author = activeLogEntry.Author,
                    fullName = uiState.fullName,
                    cpf = uiState.cpf,
                    phone = uiState.phone,
                    bound = uiState.bound,
                    photoUrl = uiState.photoUrl,
                    download = { viewModel.downloadPhoto(it) },
                    setAsUpdated = {
                        viewModel.setAsUpdated(
                            logEntry = activeLogEntry,
                            onErrorCallback = { viewModel.onErrorMessageChange(it ?: ErrorMessages.UNKNOWN.message) }
                        )
                    }
                )
            } else {
                Column(modifier = Modifier.padding(8.dp)) {
                    Card(modifier = Modifier.fillMaxHeight(0.92f).fillMaxWidth()) {
                        if (activeLogEntry != null) {
                            RecordDataRow(
                                title = "Usuário",
                                value = activeLogEntry.Author,
                                onCopy = { window.navigator.clipboard.writeText(
                                    activeLogEntry.Author) }
                            )
                            HorizontalDivider()

                            RecordDataRow(
                                title = stringResource(Res.string.full_name),
                                value = activeLogEntry.EventDetail.split("Autorizante ")[1],
                                onCopy = { window.navigator.clipboard.writeText(uiState.fullName) }
                            )
                        }
                        HorizontalDivider()
                        Icon(
                            imageVector = vectorResource(
                                if (activeLogEntry == null) Res.drawable.search_activity_24px else Res.drawable.delete_24px
                            ),
                            contentDescription = "",
                            modifier = Modifier.fillMaxSize()
                        )
                    }
                    Button(
                        onClick = {
                            if (activeLogEntry != null) {
                                viewModel.setAsUpdated(
                                    logEntry = activeLogEntry,
                                    onErrorCallback = {
                                        viewModel.onErrorMessageChange(it ?: ErrorMessages.UNKNOWN.message)
                                    }
                                )
                            }
                        },
                        modifier = Modifier.fillMaxWidth()
                    ) { Text(text = "Salvar") }

                }
            }
        }
    }
}

@Composable
fun AdminPanel(){

}

@Composable
fun LogEvent(
    isSelected: Boolean,
    onSelectionChange: () -> Unit,
    eventTimeStamp: String,
    eventDetail: String,
    eventType: String,
    databaseName: String,
) {
    Card(
        modifier = Modifier
            .padding(8.dp)
            .fillMaxWidth()
            .clickable(onClick = { onSelectionChange() }),
        colors = CardDefaults.cardColors(
            containerColor = MaterialTheme.colorScheme.secondary
        )
    ) {
        LogEntryRow(
            eventTimeStamp = eventTimeStamp,
            eventDetail = eventDetail,
            eventType = eventType,
            databaseName = databaseName,
            Clickable = {
                Checkbox(
                    checked = isSelected,
                    onCheckedChange = { onSelectionChange() }
                )
            }
        )
    }
}

@Composable
fun LogEntryRow(
    Clickable: @Composable () -> Unit,
    eventTimeStamp: String,
    eventDetail: String,
    eventType: String,
    databaseName: String,
    modifier: Modifier = Modifier
) {
    Row(
        modifier = modifier
            .height(intrinsicSize = IntrinsicSize.Min),
        verticalAlignment = Alignment.CenterVertically
    ) {
        Clickable()
        VerticalDivider(modifier = Modifier.padding(horizontal = 8.dp))
        Text(text = eventType, modifier = Modifier.weight(0.4f), textAlign = TextAlign.Center)
        VerticalDivider(modifier = Modifier.padding(horizontal = 8.dp))
        Text(text = eventDetail, modifier = Modifier.weight(2f), textAlign = TextAlign.Center)
        VerticalDivider(modifier = Modifier.padding(horizontal = 8.dp))
        Text(text = databaseName, modifier = Modifier.weight(1f), textAlign = TextAlign.Center)
        VerticalDivider(modifier = Modifier.padding(horizontal = 8.dp))
        Text(
            text = eventTimeStamp.toBrazilianDateTime(),
            modifier = Modifier.weight(1f),
            textAlign = TextAlign.Center
        )
    }
}

@Composable
fun RecordDataRow(
    title: String,
    value: String,
    onCopy: () -> Unit
) {
    Row(
        verticalAlignment = Alignment.CenterVertically,
        modifier = Modifier
            .padding(horizontal = 8.dp)
            .height(intrinsicSize = IntrinsicSize.Min)
    ) {
        Text(text = "$title: ")
        Text(text = value)
        Spacer(modifier = Modifier.weight(1f))
        IconButton(onClick = { onCopy() }) {
            Icon(
                imageVector = vectorResource(Res.drawable.content_copy_24px),
                contentDescription = "Copiar"
            )
        }

    }
}

@Composable
fun RecordData(
    author: String,
    fullName: String,
    cpf: String,
    phone: String,
    bound: String,
    photoUrl: String,
    download: (String) -> Unit,
    setAsUpdated: () -> Unit
) {
    Column(modifier = Modifier.padding(8.dp)) {
        Card(modifier = Modifier.fillMaxHeight(0.92f).fillMaxWidth()) {
            Column {
                RecordDataRow(
                    title = "Usuário",
                    value = author,
                    onCopy = { window.navigator.clipboard.writeText(author) }
                )
                HorizontalDivider()

                RecordDataRow(
                    title = stringResource(Res.string.full_name),
                    value = fullName,
                    onCopy = { window.navigator.clipboard.writeText(fullName) }
                )
                HorizontalDivider()

                RecordDataRow(
                    title = stringResource(Res.string.cpf),
                    value = cpf.toCpfFormat(),
                    onCopy = { window.navigator.clipboard.writeText(cpf) }
                )

                HorizontalDivider()

                RecordDataRow(
                    title = stringResource(Res.string.phone),
                    value = phone.toPhoneFormat(),
                    onCopy = { window.navigator.clipboard.writeText(phone) }
                )

                HorizontalDivider()

                RecordDataRow(
                    title = stringResource(Res.string.bound),
                    value = bound,
                    onCopy = { window.navigator.clipboard.writeText(bound) }
                )
                HorizontalDivider()
                Box {
                    Icon(
                        imageVector = vectorResource(Res.drawable.cloud_sync_24px),
                        contentDescription = "Sincronizando",
                        modifier = Modifier.fillMaxSize()
                    )
                    KamelImage(
                        resource = { asyncPainterResource(data = photoUrl) },
                        contentDescription = stringResource(Res.string.facial),
                        contentScale = ContentScale.Crop,
                    )
                    Row {
                        Spacer(modifier = Modifier.weight(1f))
                        IconButton(onClick = { download(photoUrl) }) {
                            Icon(
                                imageVector = vectorResource(Res.drawable.download_24px),
                                contentDescription = "Download"
                            )
                        }
                    }
                }
            }
        }
        Button(
            onClick = { setAsUpdated() },
            modifier = Modifier.fillMaxWidth()
        ) { Text(text = "Salvar") }
    }
}

